export default __webpack_public_path__ + "static/media/2021 knife block A top.72f37204.png";